import { useEditor } from '@craftjs/core';
import { getNodeHidden } from '@/utils/nodeVisibilityUtils';

interface LayerNodeState {
  isHidden: boolean;
  isLocked: boolean;
}

/**
 * Hook to get the hidden and locked state of a layer node.
 * Form fields use props.hidden (CSS hiding) to stay in DOM for form submission.
 */
export const useLayerNodeState = (nodeId: string | undefined): LayerNodeState => {
  const { isHidden, isLocked } = useEditor((_, query) => {
    if (!nodeId) return { isHidden: false, isLocked: false };
    const node = query.node(nodeId).get();
    if (!node) return { isHidden: false, isLocked: false };

    const displayName = node.data?.displayName ?? '';
    const hidden = getNodeHidden(
      displayName,
      node.data?.props?.hidden as boolean | undefined,
      node.data?.hidden,
    );

    return {
      isHidden: hidden,
      isLocked: node.data?.custom?.isLocked ?? false,
    };
  });

  return { isHidden, isLocked };
};
